import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';

const supportedLngs = ['en', 'fr', 'ar'];
const savedLanguage = typeof localStorage !== 'undefined' ? localStorage.getItem('lang') : null;

// Default to Arabic unless the user explicitly chose another supported language
const initialLanguage = supportedLngs.includes(savedLanguage)
    ? savedLanguage
    : 'ar';

const applyLanguageDirection = (lng) => {
    if (typeof document === 'undefined') {
        return;
    }

    document.documentElement.lang = lng;
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
};

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        fr: { translation: fr },
        ar: { translation: ar },
    },
    lng: initialLanguage,
    fallbackLng: 'ar',
    supportedLngs,
    interpolation: {
        escapeValue: false,
    },
    returnObjects: true
});

applyLanguageDirection(initialLanguage);
i18n.on('languageChanged', applyLanguageDirection);
//configure the text default language to arab

export default i18n;

